import { Component } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FieldWrapper, FormlyModule } from '@ngx-formly/core'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'formly-checkbox-field-type-wrapper',
  standalone: true,
  imports: [FormlyModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './checkbox-field-wrapper.component.html',
})
export class CheckboxFieldWrapperComponent extends FieldWrapper {}
